import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type Department } from '@avanta/shared/types/departments';
import { type AxiosResponse } from 'axios';

const DEPARTMENTS_URL = `${BASE_URL}departments`;

type DepartmentServiceTypes = {
  getDepartment: (departmentId: string) => Promise<AxiosResponse<Department>>;
};

export const DepartmentService: DepartmentServiceTypes = {
  getDepartment: async departmentId => service.get(`${DEPARTMENTS_URL}/${departmentId}`),
};
